import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Contractor360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/contractors/overview").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Contractor360" title="Contractor Compliance & Performance" description="Contractor registration, pre-qualification, insurance, safety files, workforce registers, permits and demobilisation." />
            <KpiGrid kpis={data?.kpis || []} accent="copper" cols={4} />
            <Panel title="Contractor Register" accent="copper">
                <DataTable
                    columns={[
                        { key: "name", label: "Firm" },
                        { key: "workforce", label: "Workforce" },
                        { key: "compliance_pct", label: "Compliance", render: (r) => `${r.compliance_pct}%` },
                        { key: "safety_ltifr", label: "LTIFR" },
                        { key: "active_since", label: "Active since" },
                        { key: "insurance_valid_until", label: "Insurance", render: (r) => r.insurance_valid_until.slice(0, 10) },
                        { key: "performance", label: "Performance", render: (r) => <StatusChip status={statusToChip(r.performance)}>{r.performance}</StatusChip> },
                    ]}
                    rows={data?.contractors || []}
                    testid="contractor-table"
                />
            </Panel>
        </div>
    );
}
